import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {CirclePersonIcon} from 'shells/icon/svg/circle-person-icon';
// @ts-expect-error - imported from .js/.jsx file
import {LockedIcon} from 'shells/icon/svg/locked-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SiteGlobeIcon} from 'shells/icon/svg/site-globe-icon';
import {Radio} from 'shells/radio/radio';
import {RadioGroupSlider} from 'shells/radio/radio-group-slider';

import styles from './share-selection.module.css';

export type ShareType = 'nobody' | 'everyone' | 'individuals';

type ShareSelectionProps = {
    onChangeShareType: (arg1: ShareType) => any;
    canShareWithIndividuals: boolean;
    shareType: ShareType;
    label?: string;
};

export class ShareSelectionComponent extends React.Component<ShareSelectionProps> {
    render() {
        const sliderIndexMap = {
            nobody: 0,
            everyone: this.props.canShareWithIndividuals ? 2 : 1,
            individuals: 1,
        }[this.props.shareType];

        return (
            <div className={styles.container}>
                {this.props.label ? (
                    <div className={styles.label}>{this.props.label}</div>
                ) : undefined}
                <RadioGroupSlider
                    name='shareType'
                    selectedValue={this.props.shareType}
                    selectedIndex={sliderIndexMap}
                    // @ts-expect-error
                    onChange={this.props.onChangeShareType}
                >
                    <Radio value='nobody'>
                        <span className={styles['radio-content']}>
                            <LockedIcon wrapWithDiv={false} size='11' />
                            Private
                        </span>
                    </Radio>
                    {this.props.canShareWithIndividuals ? (
                        <Radio value='individuals'>
                            <span className={styles['radio-content']}>
                                <CirclePersonIcon wrapWithDiv={false} size='11' />
                                Specific users
                            </span>
                        </Radio>
                    ) : null}
                    <Radio value='everyone'>
                        <span className={styles['radio-content']}>
                            <SiteGlobeIcon wrapWithDiv={false} size='11' />
                            Everyone
                        </span>
                    </Radio>
                </RadioGroupSlider>
            </div>
        );
    }
}
